import Table, { TableBody } from '@ingka/table';
import Text from '@ingka/text';
import { useFormatWithLocale } from '@lotta/self-service/lottery-fe/feature-hooks';
import type { LotteryDraw } from '@lotta/shared/types-lottery-schemas';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './DrawDetailsTable.module.scss';

export type DrawDetailsTableProps = {
  drawDetails: LotteryDraw;
  lotteryName: string;
};

export const DrawDetailsTable: React.FC<DrawDetailsTableProps> = ({ drawDetails, lotteryName }) => {
  const { t } = useTranslation();
  const { dateWithLocale, numberWithLocale } = useFormatWithLocale();
  const { nbrParticipants, nbrWinners, startDate, endDate, createdAt } = drawDetails;

  return (
    <Table>
      <TableBody className={styles['tbody']}>
        <tr key="lotteryName">
          <td className={styles['heading']}>
            <Text>{t('general-lottery-name')}</Text>
          </td>
          <td>
            <Text>{lotteryName}</Text>
          </td>
        </tr>
        <tr key="nbrParticipants">
          <td className={styles['heading']}>
            <Text>{t('draw-details-table-participants-nbr')}</Text>
          </td>
          <td>
            <Text>{numberWithLocale(nbrParticipants)}</Text>
          </td>
        </tr>
        <tr key="nbrWinners">
          <td className={styles['heading']}>
            <Text>{t('general-number-of-winners')}</Text>
          </td>
          <td>
            <Text>{numberWithLocale(nbrWinners)}</Text>
          </td>
        </tr>
        <tr key="startDate">
          <td className={styles['heading']}>
            <Text>{t('general-start-date')}</Text>
          </td>
          <td>
            <Text>{dateWithLocale(startDate)}</Text>
          </td>
        </tr>
        <tr key="endDate">
          <td className={styles['heading']}>
            <Text>{t('general-end-date')}</Text>
          </td>
          <td>
            <Text>{dateWithLocale(endDate)}</Text>
          </td>
        </tr>
        <tr key="drawDate">
          <td className={styles['heading']}>
            <Text>{t('completed-draws-table-draw-date')}</Text>
          </td>
          <td>
            <Text>{dateWithLocale(createdAt)}</Text>
          </td>
        </tr>
      </TableBody>
    </Table>
  );
};
